import { useAppDispatch, useAppSelector } from "@/config/store";
import { IEdoFile } from "@/shared/model/edo-file.model";
import { defaultValue as defaultValuePost, IEdoWallPost } from "@/shared/model/edo-wall-post.model";
import { AuthenticationState } from "@/shared/reducers/authentication";
import { createEntity } from "@/shared/reducers/entities/edo-wall-post.reducer";
import axios from "axios";
import CreatePost from "./CreatePost";

interface ICreateWallPostProps { }

const CreateWallPost = (props: ICreateWallPostProps) => {
  const dispatch = useAppDispatch();
  const { account } = useAppSelector<AuthenticationState>((state) => state.authentication);

  const createPost = (form: IEdoWallPost) => {
    dispatch(
      createEntity({
        ...form,
      })
    );
  };

  const handleUploadFiles = async (files: File[]) => {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i], files[i].name);
    }

    const response = await axios.post<{ data: IEdoFile[] }>(`/files/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data;
  };

  return (
    <CreatePost defaultValuePost={defaultValuePost} createPost={createPost} uploadFiles={handleUploadFiles} user={account} />
  );
};

export default CreateWallPost;